import { newtonConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function NewtonPage() {
  return <CityPageTemplate config={newtonConfig} />;
}